export const SET_OPTIONS = 'FOOTER/SET_OPTIONS' as const;

export const CLEANUP = 'FOOTER/CLEANUP' as const;
